<! --
/**
* SuiteCRM is a customer relationship management program developed by SuiteCRM Ltd.
* Copyright (C) 2024 SuiteCRM Ltd.
*
* This program is free software; you can redistribute it and/or modify it under
* the terms of the GNU Affero General Public License version 3 as published by the
* Free Software Foundation with the addition of the following permission added
* to Section 15 as permitted in Section 7(a): FOR ANY PART OF THE COVERED WORK
* IN WHICH THE COPYRIGHT IS OWNED BY SUITECRM, SUITECRM DISCLAIMS THE
* WARRANTY OF NON INFRINGEMENT OF THIRD PARTY RIGHTS.
*
* This program is distributed in the hope that it will be useful, but WITHOUT
* ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
* FOR A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
* details.
*
* You should have received a copy of the GNU Affero General Public License
* along with this program.  If not, see http://www.gnu.org/licenses.
*
* In accordance with Section 7(b) of the GNU Affero General Public License
* version 3, these Appropriate Legal Notices must retain the display of the
* "Supercharged by SuiteCRM" logo. If the display of the logos is not reasonably
* feasible for technical reasons, the Appropriate Legal Notices must display
* the words "Supercharged by SuiteCRM".
*/
-->
<p-sidebar [(visible)]="isSidebarVisible" [showCloseIcon]="false" (onHide)="closeSidebar()">
    <ng-template pTemplate="header">
        <div class="d-flex justify-content-start">
            <div class="flex-shrink-1">
                <button (click)="toggleSidebar()" class="navbar-toggler" type="button">
                    <scrm-image class="responsive-menu-toggler" image="hamburger"></scrm-image>
                </button>
            </div>

            <div class="d-flex flex-grow-1 justify-content-center">
                <scrm-search-bar
                        #searchBarComponent
                        [labelKey]="'LBL_FILTER_MODULES'"
                        [klass]="'search-bar-mobile-menu'"
                        [searchTrigger]="'input'"
                        (searchExpression)="search($event)">
                </scrm-search-bar>
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="content">
        <div class="sidebar-container">
            <ng-container *ngIf="displayedItems()">
                <scrm-mobile-menu [menuItems]="displayedItems"></scrm-mobile-menu>
            </ng-container>
        </div>
    </ng-template>
</p-sidebar>
